// extracted by mini-css-extract-plugin
export default {"title":"VehicleTracker_title__oiFsd","loading":"VehicleTracker_loading__zkVw5","container":"VehicleTracker_container__CgAii","btn":"VehicleTracker_btn__VUQMU"};